const updateElement = (resourceState, elementName, datatypeForChangeReport, parentResourceDetail,
    resourceChanges, dispatch, resourceUpdated, updateChangeReport) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson[elementName];
    newResourceDetail.revisedResourceJson[elementName] = resourceState[elementName];
    if (resourceState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(resourceState[elementName])
        && !(previousInitialValue === undefined &&
            JSON.stringify(resourceState[elementName]) === "[]")) {
        console.log("resourceUpdate for Resource." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            elementName,
            previousInitialValue,
            resourceState[elementName]);
    }
}

const updateNarrativeElement = (resourceState, elementName, datatypeForChangeReport, parentResourceDetail,
    resourceChanges, dispatch, resourceUpdated, updateChangeReport) => {
    let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
    let previousInitialValue = null;
    let previousFinalValue = null;
    previousInitialValue = newResourceDetail.resourceJson[elementName];
    previousFinalValue = newResourceDetail.revisedResourceJson[elementName];
    newResourceDetail.revisedResourceJson[elementName] = resourceState[elementName];
    if (resourceState[elementName] !== undefined &&
        JSON.stringify(previousFinalValue) !== JSON.stringify(resourceState[elementName])
        && !(previousFinalValue === undefined &&
            resourceState[elementName].status === "empty")) {
        console.log("resourceUpdate for Resource." + elementName);
        dispatch(resourceUpdated(newResourceDetail));
        updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
            datatypeForChangeReport,
            elementName,
            previousInitialValue,
            resourceState[elementName]);
    }
}

export default updateElement;
export { updateNarrativeElement };